module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "swiggy-logo.d1dc85ca.png" + "?" + Date.now();